import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import logo from "../assets/img/logo.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/github.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/email.svg";
export const Footer = () => {
  return (
    <footer className="footer">
      <Helmet>
        <title>Hassan ELAASEMY - Mobile Developer</title>
        <meta
          name="description"
          content="Hassan ELAASEMY - Mobile Developer. Connect with me on LinkedIn, GitHub, and Instagram."
        />
        <meta name="author" content="Hassan ELAASEMY" />
        <meta
          name="keywords"
          content="web development, React Js, React Native , JavaScript"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Hassan ELAASEMY - Mobile Developer"
        />
        <meta
          property="og:description"
          content="Connect with me on LinkedIn, GitHub, and Instagram."
        />
        <meta property="og:image" content="URL_TO_IMAGE" />
        <meta property="og:url" content="URL_TO_PAGE" />
      </Helmet>
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/hassan-elaasemy-05a977231/"
                target="_blank"
              >
                <img src={navIcon1} alt="LinkedIn Icon" />
              </a>
              <a href="https://github.com/hassanelaasemy" target="_blank">
                <img src={navIcon2} alt="GitHub Icon" />
              </a>
              <a href="https://www.instagram.com/devit_web/" target="_blank">
                <img src={navIcon3} alt="Instagram Icon" />
              </a>
              <a href="mailto:elaasemyhassan01@gmail.com" target="_blank">
                <img src={navIcon4} alt="" />
              </a>
            </div>
            <p>Hassan ELAASEMY 2024. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
